import { isABN } from '__core/shared/util/validate';
import template from './illionCompanyExtractPlusDialog.template.html';

export default {
  bindings: {
    onFinished: '&',
    idTicket: '<',
    latestScore: '<',
    isIllionEnabled: '<',
    contact: '<',
    loanAmount: '<'
  },
  controller: class controller {
    constructor(
      $rootScope,
      $filter,
      $mdDialog,
      eventService,
      illionService,
      ContactCreditScore,
      Contact,
      contactService,
      uiService,
      notesService,
      ILLION
    ) {
      'ngInject';

      const $ctrl = this;

      $ctrl.initialize = () => {
        $mdDialog
          .show({
            targetEvent: '',
            locals: {
              isIllionEnabled: $ctrl.isIllionEnabled,
              contact: $ctrl.contact,
              loanAmount: $ctrl.loanAmount,
              idTicket: $ctrl.idTicket
            },
            template,
            controllerAs: '$ctrl',
            multiple: true,
            controller(isIllionEnabled, contact, loanAmount, idTicket) {
              const ctrl = this;
              ctrl.idTicket = idTicket;
              ctrl.latestScore = $ctrl.latestScore;
              ctrl.isReady = true;
              ctrl.creditScore = null;
              ctrl.isIllionEnabled = isIllionEnabled;
              ctrl.loanAmount = loanAmount || 1;
              ctrl.CurrentCurrency = $rootScope.CurrentCurrency;
              ctrl.availableLookupMethods = ILLION.LOOKUP_METHOD;
              ctrl.contact = Contact.build(JSON.parse(JSON.stringify(contact)));
              ctrl.lookupValue = ctrl.contact?.company?.information?.refNumber;
              ctrl.isABN = isABN(ctrl.lookupValue);
              ctrl.lookupMethod = ctrl.isABN ? 'ABN' : 'ACN';
              ctrl.isErrorResponse = false;
              ctrl.error = '';

              ctrl.hasErrors = () =>
                !ctrl.isIllionEnabled || !ctrl.contact.company.information.refNumber;

              ctrl.confirm = () => {
                if (!ctrl.sendIllion.$valid || ctrl.hasErrors()) {
                  return;
                }
                ctrl.isReady = false;
                illionService
                  .companyExtractPlus({
                    idTicket: ctrl.idTicket,
                    idContact: ctrl.contact.id,
                    lookupMethod: ctrl.lookupMethod,
                    lookupValue: ctrl.lookupValue
                  })
                  .then((result) => {
                    if (result.status) {
                      ctrl.creditScore = result.results;
                      ctrl.isReady = true;

                      uiService.toast({
                        text: {
                          p1: 'Company Extract Plus',
                          p2: 'retrieved',
                          p3: 'and saved'
                        },
                        success: true,
                        warn: false
                      });
                      $mdDialog.hide({
                        idContact: ctrl.contact.id,
                        creditScore: [].concat(ctrl.creditScore)
                      });
                    } else {
                      ctrl.isErrorResponse = true;
                      ctrl.error = result.errorMessage;
                    }
                  })
                  .catch(() => {
                    ctrl.isReady = true;
                  });
              };
              ctrl.cancel = () => {
                $mdDialog.hide();
              };
            }
          })
          .then((result) => {
            $ctrl.onFinished(result);
          });
      };

      $ctrl.$onInit = () => {
        $ctrl.initialize();
      };
    }
  }
};
